import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TournamentService } from 'src/app/modules/tournament/tournament.service';
import TabBase from '../tab-base';
import { NbWindowService } from '@nebular/theme';
import { SharedH2hComponent } from '@theme/components';

@Component({
    selector: 'app-tab-matchs',
    templateUrl: './matchs.component.html',
    styleUrls: ['./matchs.component.scss'],
})
export class MatchsComponent extends TabBase implements OnInit {
    @Input() tournamentId: string;
    /**
     * matches
     */
    matches;

    /**
     * filters
     */
    filters;

    /** loadAll */
    loadAll = 1;

    /* Paginação */
    perPage: number = 8;
    page: number = 1;

    destroy$: Subject<any> = new Subject();
    loading: boolean;
    statusCode: number;

    constructor(private route: ActivatedRoute, private windowService: NbWindowService) {
        super();
    }

    ngOnInit(): void {
        this.getMatches();
    }

    private getMatches(filters = null) {
        const { categoryId } = this.route.snapshot.params;
        this.loading = true;
        this.tournamentService
            .getMatches(this.tournamentId, categoryId, filters)
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
                console.log(response);
                this.matches = this.loadAll ? response.registers.list : this.matches;
                this.filters = response.registers.filters;
                this.statusCode = response.status_code;
                this.loading = false;
            });
    }

    /**
     * onFilterChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFilterChange(event) {
        this.getMatches(event);
        /**
         * TODO: fix me
         */
        this.loadAll = event.loadAll;
    }

    onMatchClick(match) {
        this.windowService.open(SharedH2hComponent, {
            title: 'Detalhes do confronto',
            context: {
                ...match,
            },
            windowClass: 'no-extra-buttons',
        });
    }
}
